export default {

    data() {
        return {
            paymentTypeToBreakdownFields: {
                monthly: ['licenseSubtotal', 'licenseSalesTax', 'recurringPayment', 'hardwareSubtotal', 'hardwareSalesTax', 'shippingAndHandling', 'shippingAndHandlingTax', 'renewalCreditAmount', 'initialPayment'],
                annual: ['licenseSubtotal', 'licenseSalesTax', 'recurringPayment', 'hardwareSubtotal', 'hardwareSalesTax', 'shippingAndHandling', 'shippingAndHandlingTax', 'renewalCreditAmount', 'initialPayment'],
                upfront: ['upfrontFee', 'salesTax', 'shippingAndHandling', 'shippingAndHandlingTax', 'renewalCreditAmount', 'initialPayment']
            }
        }
    },

    computed: {
        licenseSubtotal() {
            return {
                label: () => {
                    return this.checkoutContent.pricingBreakdownTerms['license_subtotal'];
                },
                value: () => {
                    return this.productCostsInfo.subtotals.software[this.paymentType];
                },
                display: () => {
                    return this.paymentType !== "upfront";
                },
            }
        },
        licenseSalesTax() {
            return {
                label: () => {
                    return `${this.checkoutContent.pricingBreakdownTerms['license_sales_tax']} (${(this.productCostsInfo.software_tax_rate * 100).toFixed(2)}%)`;
                },
                value: () => {
                    return this.productCostsInfo.taxes.software[this.paymentType];
                },
                display: () => {
                    return this.paymentType !== "upfront";
                },
            }
        },
        recurringPayment() {
            return {
                label: () => {
                    return this.checkoutContent.pricingBreakdownTerms[`recurring_${this.paymentType}_payment`];
                },
                value: () => {
                    return this.productCostsInfo.totals.software[this.paymentType];
                },
                display: () => {
                    return this.paymentType !== "upfront";
                },
            }
        },
        upfrontFee() {
            return {
                label: () => {
                    return this.checkoutContent.pricingBreakdownTerms['upfront_fee'];
                },
                value: () => {
                    return this.productCostsInfo.order_subtotals.upfront;
                },
                display: () => {
                    return this.paymentType === "upfront";
                },
            }
        },
        hardwareSubtotal() {
            return {
                label: () => {
                    return this.checkoutContent.pricingBreakdownTerms['hardware_subtotal'];
                },
                value: () => {
                    return this.productCostsInfo.subtotals.hardware[this.paymentType];
                },
                display: () => {
                    return this.paymentType !== "upfront";
                },
            }
        },
        hardwareSalesTax() {
            return {
                label: () => {
                    return `${this.checkoutContent.pricingBreakdownTerms['hardware_sales_tax']} (${(this.productCostsInfo.hardware_tax_rate * 100).toFixed(2)}%)`;
                },
                value: () => {
                    return this.productCostsInfo.taxes.hardware[this.paymentType];
                },
                display: () => {
                    return this.paymentType !== "upfront";
                },
            }
        },
        salesTax() {
            return {
                label: () => {
                    if (['united states', 'canada', 'mexico'].includes(this.shipping.country.toLowerCase())) {
                        return `${this.checkoutContent.pricingBreakdownTerms['sales_tax']} (${(this.productCostsInfo.blended_tax_rate * 100).toFixed(2)}%)`;
                    }
                    return `${this.checkoutContent.pricingBreakdownTerms['value_added_tax']}  (${(this.productCostsInfo.blended_tax_rate * 100).toFixed(2)}%)`;
                },
                value: () => {
                    return this.productCostsInfo.order_taxes.upfront;
                },
                display: () => {
                    return this.paymentType === "upfront";
                },
            }
        },
        shippingAndHandling() {
            return {
                label: () => {
                    return this.checkoutContent.pricingBreakdownTerms['shipping_and_handling'];
                },
                value: () => {
                    return this.productCostsInfo.additional_upfront_line_items.shipping_and_handling;
                },
                display: () => {
                    return true;
                },
            }
        },
        shippingAndHandlingTax() {
            return {
                label: () => {
                    return this.checkoutContent.pricingBreakdownTerms['shipping_and_handling_tax'];
                },
                value: () => {
                    return this.productCostsInfo.additional_upfront_line_items.shipping_and_handling_tax;
                },
                display: () => {
                    return this.productCostsInfo.additional_upfront_line_items.shipping_and_handling_tax > 0;
                }
            }
        },
        renewalCreditAmount() {
            return {
                label: () => {
                    return this.checkoutContent.pricingBreakdownTerms['renewal_credit_amount'];
                },
                value: () => {
                    return this.productCostsInfo.additional_upfront_line_items.renewal_credit * -1;
                },
                display: () => {
                    return this.productCostsInfo.additional_upfront_line_items.renewal_credit > 0;
                },
            }
        },
        initialPayment() {
            return {
                label: () => {
                    return this.checkoutContent.pricingBreakdownTerms[`initial_${this.paymentType}_payment`];
                },
                value: () => {
                    return this.productCostsInfo.order_totals[this.paymentType];
                },
                display: () => {
                    return true;
                },
            }
        },
    },
}